import { placeholderPattern } from "src/lib/placeholders/placeholderTokens.ts";

/** Метка, по которой редактор узнаёт свой чип при разборе HTML. */
export const CHIP_ATTRIBUTE = "data-placeholder";

/**
 * Чип вместе с неразрывными пробелами, которые редактор ставит вокруг него.
 *
 * Обычный пробел рядом с инлайновым предметом браузер схлопывает, поэтому
 * CKEditor на выгрузке меняет его на неразрывный — и текст, прошедший через
 * редактор, переставал совпадать с исходным. Ловим эти пробелы вместе с чипом
 * и возвращаем обратно обычные: свой неразрывный пробел вплотную к
 * плейсхолдеру никто не ставит, а вот молча испорченный текст заметить нечем.
 *
 * Записан он бывает обоими способами — символом и мнемоникой `&nbsp;`, — и
 * какой достанется, зависит от того, как редактор собрал разметку. Ловим оба:
 * ловили только символ, и в письме оставалось `Hallo&nbsp;{{ ... }}`.
 */
const MARKED = new RegExp(
  `((?:\u00a0|&nbsp;)?)<span ${CHIP_ATTRIBUTE}="([^"]+)">\\s*\\{\\{[^{}]*\\}\\}\\s*</span>((?:\u00a0|&nbsp;)?)`,
  "gi",
);

export const chipMarkup = (token: string): string =>
  `<span ${CHIP_ATTRIBUTE}="${token}">{{ ${token} }}</span>`;

/**
 * Оборачивает голые токены разметкой, которую понимает редактор.
 *
 * Нужно на загрузке: в базе лежит обычный текст, и письма, написанные до
 * появления чипов, обязаны открываться чипами — иначе половина текстов ведёт
 * себя одним образом, половина другим, и объяснить это пользователю нечем.
 */
export const wrapTokens = (html: string): string =>
  html.replace(placeholderPattern(), (_whole, token: string) =>
    chipMarkup(token),
  );

/**
 * Снимает обёртку обратно, оставляя ровно `{{ token }}`.
 *
 * Вызывается на выгрузке, и это главное обещание всей затеи: в базу уходит то
 * же, что уходило раньше. Brevo, Twig, проверка неисполнимых плейсхолдеров и
 * подмена кодов купонов в тестовом письме продолжают видеть привычный текст и
 * ничего не знают о редакторе.
 */
export const unwrapTokens = (html: string): string =>
  html.replace(
    MARKED,
    (_whole, before: string, token: string, after: string) =>
      `${before === "" ? "" : " "}{{ ${token} }}${after === "" ? "" : " "}`,
  );
